@use 'src/global/variables.scss' as var;

$breakpoints: (phone: 640px,
               tablet: 768px,
               desktop: 1024px) !default;

:host {
  display: inline;
  hyphens: none;
  word-break: break-word;
  overflow-wrap: break-word;
}

#cb-header {
  .glow-unset {
    box-shadow: unset !important;
  }

  .glow-inset {
    box-shadow: inset 0 -5px 5px -2px white !important;
    padding: 12px 12px 17px 12px !important;
  }
}

#cb-floating-button {
  z-index: 1000;
  background-color: #020e25;
  border-radius: 50%;
  font-size: 1rem;
  padding: 0;
  border: none;
  cursor: pointer;
  position: fixed; // Todo Instead position host with fixed and give host width and height and for button just 100%, so consumer can position the element from outside
  bottom: var.$bot-position;
  right: var.$bot-position;

  @media screen and (max-width: 768px) {
    width: var.$button-diameter-small;
    height: var.$button-diameter-small;
  }
  @media screen and (min-width: 769px) {
    width: var.$button-diameter;
    height: var.$button-diameter;
  }

  justify-content: center;
  align-items: center;

  &.hide-floating-button {
    display: none;
    pointer-events: none;
    cursor: none; // Todo Not working. Still get pointer
  }

  &:focus,
  &:hover {
    outline: none;
    box-shadow: 0 0 0 4px var.$focus-color;
    &.hide-floating-button {
      box-shadow: none;
    }
  }

  .triangle {
    position: absolute;

    @media screen and (max-width: 768px) {
      bottom: 2px;
      right: -1px;
    }
    @media screen and (min-width: 769px) {
      bottom: 3px;
      right: 0;
    }

    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 20px 10px;
    border-color: transparent transparent var.$primary-color transparent;
    color: var.$primary-color;
    transform: rotate(20deg);
  }

  #cb-tip {
    z-index: -1;
  }

  @media print {
    .noPrint {
      display:none !important;
    }
  }

  #cb-triangle-focus {
    display: none;
    bottom: -2px;
    right: -4px;
    border-width: 0 10px 20px 10px;
    border-color: transparent transparent var.$focus-color transparent;
  }

  &:focus > #cb-triangle-focus,
  &:hover > #cb-triangle-focus {
    display: block;
  }
}
